<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  @select="handleSelectDistribuidor"
                  id-prefix="maestrodocumentosfilter"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                @select="handleSelectCliente"
                id-prefix="maestrodocumentosfilter"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NumDiligencia')}}
                <el-form-item prop="NumDiligencia">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NumDiligencia.value"
                    maxlength="15"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <span id="procedings-filter-ticket-id-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.TicketID')}}</span>
              <el-form-item prop="ticketId">
                <el-input
                  aria-labelledby="procedings-filter-ticket-id-label"
                  class="w-full"
                  v-model="form.ticketId.value"
                  maxlength="150"
                >
                <template v-if="form.ticketId.value" slot="suffix">
                  <base-clear-input-button
                    aria-label="Limpiar campo de TicketID"
                    @clear="form.ticketId.value = ''"
                  />
                </template>
              </el-input>
              </el-form-item>
            </div>
            
            <div>
              <AccessibleElSelect
                v-model="form.tipoDiligencia.value"
                prop="tipoDiligencia"
                :options="TiposForAccessibleSelect"
                :withFormItem="true"
                id-prefix="procedingsfilter"
                @select="handleSelectTipo"
              >
                <template slot="label">{{$t('procedings.Tipo')}}</template>
              </AccessibleElSelect>
            </div>
            
            <div>
              <AccessibleElSelect
                v-model="form.tipoDiligenciaEstado.value"
                prop="tipoDiligenciaEstado"
                :options="EstadosForAccessibleSelect"
                :withFormItem="true"
                id-prefix="procedingsfilter"
                @select="handleSelectEstado"
              >
                <template slot="label">{{$t('procedings.Estado')}}</template>
              </AccessibleElSelect>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NIFPagadora')}}
                <el-form-item prop="NIFPagadora">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NIFPagadora.value"
                    maxlength="9"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NIFDeudor')}}
                <el-form-item prop="NIFDeudor">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NIFDeudor.value"
                    maxlength="9"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.CSV')}}
                <el-form-item prop="CSV">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CSV.value"
                    maxlength="30"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.Error')}}
                <el-form-item prop="Error">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Error.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { ROLES } from '@/config/roles'
import { TIPOS_DILIGENCIAS } from '@/config/tipos-diligencias'
import { TIPOS_DILIGENCIAS_ESTADO } from '@/config/tipos-diligencias-estado'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'procedings',
      isOpen: this.panelOpen,
      form: {
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        NumDiligencia: { label: i18n.t('procedings.NumDiligencia'), value: '' },
        ticketId: { label: 'Ticket ID', value: '' },
        tipoDiligencia: { label: i18n.t('procedings.Tipo'), value: '' },
        tipoDiligenciaEstado: { label: i18n.t('procedings.Estado'), value: '' },
        NIFPagadora: { label: i18n.t('procedings.NIFPagadora'), value: '' },
        NIFDeudor: { label: i18n.t('procedings.NIFDeudor'), value: '' },
        CSV: { label: i18n.t('procedings.CSV'), value: '' },
        Error: { label: i18n.t('procedings.Error'), value: '' },
      },
      tiposDiligencias: TIPOS_DILIGENCIAS,
      tiposDiligenciasEstado: TIPOS_DILIGENCIAS_ESTADO,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    TiposForAccessibleSelect: function () {
      return this.tiposDiligencias.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    EstadosForAccessibleSelect: function () {
      return this.tiposDiligenciasEstado.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.NumDiligencia.value = _temp.NumDiligencia !== undefined && _temp.NumDiligencia.value !== '' ? _temp.NumDiligencia.value : ''
        this.form.ticketId.value = _temp.ticketId !== undefined && _temp.ticketId.value !== '' ? _temp.ticketId.value : ''
        this.form.tipoDiligencia.value = _temp.tipoDiligencia !== undefined && _temp.tipoDiligencia.value !== '' ? _temp.tipoDiligencia.value : ''
        this.form.tipoDiligenciaEstado.value = _temp.tipoDiligenciaEstado !== undefined && _temp.tipoDiligenciaEstado.value !== '' ? _temp.tipoDiligenciaEstado.value : ''
        this.form.NIFPagadora.value = _temp.NIFPagadora !== undefined && _temp.NIFPagadora.value !== '' ? _temp.NIFPagadora.value : ''
        this.form.NIFDeudor.value = _temp.NIFDeudor !== undefined && _temp.NIFDeudor.value !== '' ? _temp.NIFDeudor.value : ''
        this.form.CSV.value = _temp.CSV !== undefined && _temp.CSV.value !== '' ? _temp.CSV.value : ''
        this.form.Error.value = _temp.Error !== undefined && _temp.Error.value !== '' ? _temp.Error.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        NumDiligencia: { label: i18n.t('procedings.NumDiligencia'), value: '' },
        ticketId: { label: 'Ticket ID', value: '' },
        tipoDiligencia: { label: i18n.t('procedings.Tipo'), value: '' },
        tipoDiligenciaEstado: { label: i18n.t('procedings.Estado'), value: '' },
        NIFPagadora: { label: i18n.t('procedings.NIFPagadora'), value: '' },
        NIFDeudor: { label: i18n.t('procedings.NIFDeudor'), value: '' },
        CSV: { label: i18n.t('procedings.CSV'), value: '' },
        Error: { label: i18n.t('procedings.Error'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    handleSelectTipo: function (item) {
      this.form.tipoDiligencia.value = item.id
    },
    handleSelectEstado: function (item) {
      this.form.tipoDiligenciaEstado.value = item.id
    },
  }
}
</script>
